import { Box, Chip } from '@material-ui/core'
import { useState, useEffect } from 'react'
import './amsproductcount.css'

const AmsProductCount = (props: any) => {

    const { text,index, count, onDecrementClick, onIncrementClick } = props

    const [prodCount, setProdCount] = useState(1);

    const handleDecrement = () => {
        // if (prodCount > 1) {
            setProdCount((prev) => prev - 1)
            onDecrementClick(index,count)
        // }

    }

    const handleIncrement = () => {
        setProdCount((prev) => prev + 1)
        onIncrementClick(count)
    }

    return (
        <Box className='productCountItem'>
            {count > 0 && (<><Box className='decrement' onClick={handleDecrement}>-</Box>
                <Chip label={`${count} ${text}`} className='productChip' />
                <Box className='increment' onClick={handleIncrement}>+</Box></>)}
        </Box>
    )
}

export default AmsProductCount